import React from "react";
import PageHeader from "../main/PageHeader";
import EntityApi from "../../api/EntityApi";
import { DatePicker } from 'antd';
import Button from '../element/Button';
import dayjs from "dayjs";

const AccessUserForm = ({userId, openList, onReload, preSelect}) => {

    const [input, setInput] = React.useState('');
    const [items, setItems] = React.useState([]);
    const [selectId, setSelectId] = React.useState(0);
    const [selectItem, setSelectItem] = React.useState(null);
    const [dateFrom, setDateFrom] = React.useState('');
    const [dateTo, setDateTo] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);

    const handleKeyDown = (evt) => {
        if(evt.key === 'Enter' && input.length > 1){

            setSelectItem(null);
            setSelectId(0);

            let filter = {
                search: input
            }

            EntityApi.getBy('private/product', {
                'filter': filter
            }).then((data) => {
                if (data.status === 'success') {
                    let items = [];
                    if (data.content.items) {
                        data.content.items.forEach((item) => {
                            items.push({
                                id: item.id,
                                title: item.title,
                                code: item.code,
                                image: item.picture?.url,
                                access: item.access
                            });
                        })
                    }
                    setItems(items);
                }
            });
        }
    }

    const handlerSelectItem = (id) => {
        setSelectId(id);
        items.forEach((item) => {
            if (item.id === id) {
                setSelectItem(item);
                setItems([]);
                setInput('');
            }
        })
    }

    const onChangeDateFrom = (date, dateString) => {
        setDateFrom(dateString);
    };

    const onChangeDateTo = (date, dateString) => {
        setDateTo(dateString);
    };

    const onSave = () =>
    {
        setIsLoading(true);
        console.log(selectId, dateFrom, dateTo);
        EntityApi.put('private/access', {
            entity_type: 'product',
            entity_id: selectId,
            user_id: userId,
            date_from: dateFrom,
            date_to: dateTo,
        }).then((data) => {
            setIsLoading(false);
            if (data.status === 'success') {
                setSelectItem(null);
                setItems([]);
                setInput('');
                onReload();
                openList();
            }
        })
    }

    React.useEffect(() => {
        if (preSelect) {
            console.log(preSelect);
            setSelectId(preSelect.entity_id);
            setSelectItem(preSelect);
            if (preSelect.date_from) {
                setDateFrom(preSelect.date_from);
            } else {
                setDateFrom(null);
            }
            setDateTo(preSelect.date_to);
            setItems([]);
            setInput('');
        }
    }, [preSelect])

    return <>
        <div
            className="flex flex-col items-center space-y-4 border-b border-slate-200 p-4 dark:border-navy-500 sm:flex-row sm:justify-between sm:space-y-0 sm:px-5">
            <h2 className="text-lg font-medium tracking-wide text-slate-700 dark:text-navy-100">
                Добавить/Изменить доступ к курсу
            </h2>
        </div>
        <div className="p-4 sm:p-5">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <label className="block">
                    <input
                        className="form-input w-full rounded-full border border-slate-300 bg-transparent px-4 py-2 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent"
                        placeholder="Введите код или название курса для поиска"
                        type="text" onChange={(evt) => setInput(evt.target.value)}
                        value={input} onKeyDown={handleKeyDown}
                    />
                </label>
            </div>
            <ul className="space-y-1.5 font-inter font-medium mt-4">
                {/*<li>
                    <a className="flex rounded-lg bg-primary px-4 py-2.5 tracking-wide text-white outline-none transition-all dark:bg-accent"
                       href="#">
                        <span>Getting start</span>
                    </a>
                </li>*/}
                {
                    items.map((item) =>
                <li key={item.id}>
                    <button onClick={() => handlerSelectItem(item.id)} className="flex rounded-lg text-left px-4 py-2.5 tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 focus:bg-slate-100 focus:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100">
                        <span>[Код: {item.code}] {item.title}</span>
                    </button>
                </li>
                    )
                }
            </ul>
            {
                selectItem &&
                <>
                    <h2 className={'text-lg font-medium'}>
                        { selectItem.code ? '[Код: ' + selectItem.code + '] ' : '' }
                        {selectItem.title}</h2>
                    <div className={'mt-4'}>
                        <div className="alert flex overflow-hidden rounded-lg border border-info text-info">
                            <div className="bg-info p-3 text-white">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                </svg>
                            </div>
                            <div className="px-4 py-3 sm:px-5">
                                Выберите срок доступа. Если требуется бессрочный доступ, оставьте поля пустыми.
                                <br />
                                Если на данный курс уже есть доступ, он обновится указанными данными.
                            </div>
                        </div>
                    </div>
                    <div className={'mt-4 mb-4 flex mob-flex-wrap'}>
                        <DatePicker onChange={onChangeDateFrom}
                                    value={dateFrom ? dayjs(dateFrom, 'DD.MM.YYYY') : ''}
                                    placeholder={'от даты'} format={'DD.MM.YYYY'}/>
                        <div className={'ml-1 mr-1'}>-</div>
                        <DatePicker onChange={onChangeDateTo}
                                    value={dateTo ? dayjs(dateTo, 'DD.MM.YYYY') : ''}
                                    placeholder={'до даты'} format={'DD.MM.YYYY'}/>
                        <div className={'w-3/12 ml-4 mob-w-full mob-mt-2 mob-ml-0'}>
                            <Button onClick={onSave} disabled={isLoading} type={isLoading ? 'default' : 'primary'} text={'Предоставить доступ'}/>
                        </div>
                    </div>
                </>
            }
        </div>
    </>
}

export default AccessUserForm;
